import { AlertCircle } from 'lucide-react'

export type MinorWarningNoticeProps = {
  age?: number
}

export function MinorWarningNotice({ age }: MinorWarningNoticeProps) {
  const ageLine =
    typeof age === 'number'
      ? `Because you are ${age} years old (under 18),`
      : 'Because you are under 18 years old,'

  return (
    <div className="rounded-r-md border-l-4 border-amber bg-amber-soft p-4">
      <div className="flex gap-3">
        <AlertCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-amber" aria-hidden />
        <div className="flex flex-col gap-1">
          <h3 className="text-sm font-semibold text-amber">
            Parent/Guardian Signature Required
          </h3>
          <p className="text-sm text-amber">
            {ageLine} a parent or legal guardian must complete and sign the waiver on your behalf.
            Please ensure the person signing is 18 or older and has the authority to sign for you.
          </p>
        </div>
      </div>
    </div>
  )
}
